import { Injectable } from "@angular/core";
import { AnalyticsService } from "../analytics.service";
import { CommonService } from "../common.service";
import { UserPreference } from "../../models/UserPreference";
import { appSettings, errorMessages } from "../../settings";
import { DateRangeParam } from "../../models/DateRangeParam";
import { WidgethelperService } from "../widgethelper.service";
import { TransitionalInventoryParam } from "../../models/TransitionalInventoryParam";

@Injectable()
export class TransitionalInventoryService {
  constructor(
    private _analyticsService: AnalyticsService,
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService
  ) { }

  chartOptions() {
    return {
      color:['#3398DB', '#DBB55E', '#fbb03b', '#f7931e', '#F27921', '#F25F1A', '#BF3C26', '#F2263C', '#8A26F2', '#7434F2', '#4333BF', '#6455F2', '#708AF2', '#7FB1F2', '#8DD6F2', '#4FFFE8', '#3EFFB1', '#d48265', '#91c7ae', '#597764', '#ca8622'],
      title: {
        text: "",
        textStyle: {
          color: "#fff"
        }
      },
      grid: {
        top: '10%'
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: ["Item Count","On Hand Quantity"],
        top: '5%',
        textStyle: {
          color: "#fff"
        }
      },
      xAxis: {
        type: "category",
        data: [],
        nameTextStyle: {
          color: "#fff"
        },
        axisLabel: {
          interval: 0,
          length: "100%",
          rotate: 30,
          color: "#fff"
        },
        splitArea: {
          show: false
        },
        axisLine: {
          lineStyle: {
            color: '#fff'
          }
        },
      },
      yAxis: [
        {
          name:'Count',
          splitLine: {
            show: false
          },
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#fff"
            }
          }
        }
      ],
      series: [
        {
          name: "Item Count",
          type: "bar",
          stack: '1',
          barWidth: '30',
          yAxisIndex:0,
          data: []
        },
        {
          name: "On Hand Quantity",
          type: "bar",
          barWidth: '30',
          stack: '1',
          yAxisIndex:0,
          data: []
        }
      ]
    };
  }

  init(widget: any) {
    console.log("Transitional Inventory");
    widget.dataLoaded = false;
    widget.Title = "Transitional Inventory";
    let userPref: UserPreference = this._commonService.getUserPreference();
    let criteria: TransitionalInventoryParam = new TransitionalInventoryParam();
    let dateParam: DateRangeParam = new DateRangeParam();
    let setting = widget.widgetsettings;
    (dateParam.RangeValue = this._widgetHelper.GetSummaryType(
      setting.PickType
    ));
    (dateParam.RangeNumber = this._widgetHelper.GetSummaryTypeNo(
      setting.PickType
    ));

    this._analyticsService.getDates(dateParam).subscribe(
      data => {
        if (
          data.Start_Date.toString() != "0001-01-01T00:00:00" &&
          data.End_Date.toString() != "0001-01-01T23:59:59.999"
        ) {
          criteria.StartDate = new Date(data.Start_Date);
          criteria.EndDate = new Date(data.End_Date);
          criteria.CustomerId = userPref.CustomerId;
          criteria.FacilityId = userPref.FacilityId;
          criteria.SummaryType = setting.MonitorType;
          console.time("getTransitionalInventory");
          this._analyticsService.getTransitionalInventory(criteria).subscribe(
            (result: any) => {
              console.timeEnd("getTransitionalInventory");
              let Report_Periods = [];
              let ITEM_COUNT = [];                
              let ON_HAND_QUANTITY = [];    

              widget.chartOptions = this.chartOptions();
              widget.errorMessage = null;
              if (result && result.length > 0) {
                for (let i = 0; i < result.length; i++) {
                  let rptdate = "";
                  if (criteria.SummaryType == "D") {
                    rptdate = this._commonService.formatDate(
                      result[i].REPORT_DATE,
                      appSettings.chartDayFormat
                    );
                  }
                  if (criteria.SummaryType == "W") {
                    rptdate = this._commonService.formatDate(
                      result[i].REPORT_DATE,
                      appSettings.chartDayFormat
                    );
                  }
                  if (criteria.SummaryType == "M") {
                    rptdate = result[i].MONTH_ABBR_NAME;
                  }
                  if (criteria.SummaryType == "Q") {
                    //rptdate = (kpiData[i].QUARTER_NAME);
                    rptdate =
                      result[i].YEAR_NUMBER +
                      " QTR" +
                      result[i].QUARTER_NUMBER;
                  }
                  if (rptdate != '' && Report_Periods.indexOf(rptdate) == -1) {
                    Report_Periods.push(rptdate);
                  }

                  ITEM_COUNT.push([rptdate, result[i].ITEM_COUNT]);
                  ON_HAND_QUANTITY.push([rptdate, result[i].ON_HAND_QUANTITY]);
                }

                // for (let i = 0; i < result.length; i++) {
                //   let rptdate = result[i].MONTH_ABBR_NAME;
                //   Report_Periods.push(rptdate);
                //   ITEM_COUNT.push([rptdate, result[i].ITEM_COUNT]);
                //   ON_HAND_QUANTITY.push([rptdate, result[i].ON_HAND_QUANTITY]);
                // }
              } else {
                widget.errorMessage = errorMessages.noWidgetData;
              }
              widget.chartOptions.series[0].data = ITEM_COUNT;
              widget.chartOptions.series[1].data = ON_HAND_QUANTITY;
              widget.chartOptions.xAxis.data = Report_Periods;
              widget.dataLoaded = true;
            },
            err => {
              console.timeEnd("getTransitionalInventory");
              console.log("getTransitionalInventory", err);
              widget.dataLoaded = true;
              widget.errorMessage = errorMessages.apiError;
            }
          );
        }
      },
      err => {
        console.log("getDates", err);
        widget.dataLoaded = true;
        widget.errorMessage = errorMessages.apiError;
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/services/widgets/transitional-inventory.service.ts